export const TYPE_REQUEST_FACTS = 'facts/REQUEST_FACTS';
export const TYPE_RECEIVE_FACTS = 'facts/RECEIVE_FACTS';
